<script setup lang="ts">
import VimeoPlayer from '@/components/VimeoPlayer/VimeoPlayer.vue'
</script>

<template>
  <div
    id="zobacz-film"
    class="careerMainVideo"
  >
    <UiHeader
      :header="$t('career.mainVimeoComponent.title') "
      position="center"
      header-size="h5"
      header-size-tablet="h5"
      header-size-mobile="h5"
    />

    <p class="careerMainVideo__paragraph">
      {{ $t('career.mainVimeoComponent.paragraph') }}
    </p>

    <p class="careerMainVideo__secondParagraph">
      {{ $t('career.mainVimeoComponent.secondParagraph') }}
    </p>

    <VimeoPlayer
      :src="'https://player.vimeo.com/video/1095557467?h=152b7483ef&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'"
      ,
      :title="'MultiMożliwości w Benefit Systems'"
    />
  </div>
</template>

<style lang="scss" scoped>
.careerMainVideo {
  &__paragraph {
    @include body-2-medium;
    padding: 2rem 2.4rem 2.4rem;
    color: $text-400;
    text-align: center;
  }

  &__secondParagraph {
    @include body-2-medium;
    padding: 0 2.4rem 2.4rem;
    color: $text-400;
    font-style: italic;
  }

  @include atM {
    &__paragraph {
      @include h8;
    }

    &__secondParagraph {
      @include h8;
      text-align: center;
    }
  }
}
</style>

